module.exports = __webpack_public_path__ + "img/icon_4.b90d2a9d.png";